export const SPECIALIZATIONS = [
  "Family Law", "Criminal Law", "Property Law", "Corporate Law", "Consumer Rights", "Labour Law",
  "Tax Law", "Intellectual Property", "Immigration Law", "Cyber Law", "Civil Law", "Constitutional Law",
  "Banking & Finance", "Insurance Law", "Real Estate & RERA", "Motor Accident Claims", "Startup & Compliance",
  "Arbitration & Mediation", "Environmental Law", "Medical Negligence", "Other",
];
export const MAX_SPECIALIZATIONS = 5;

/** Normalise a lawyer/application record to a list (legacy single `specialization` → [value]). */
export const specializationsOf = (rec) =>
  (Array.isArray(rec?.specializations) && rec.specializations.length ? rec.specializations : rec?.specialization ? [rec.specialization] : []);
